<div class="relative-div">
    @if (loading()) {
    <div class="spinner-overlay">
        <mat-spinner></mat-spinner>
    </div>
    }
    <table mat-table [dataSource]="registrationsDataSource" matSort matSortActive="id" matSortDirection="asc"
        multiTemplateDataRows>
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">Id</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{r.id}} </td>
        </ng-container>
        <ng-container matColumnDef="seqNum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">#</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{r.seqNum}} </td>
        </ng-container>
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-10pc-column r-th">Registration date</th>
            <td mat-cell *matCellDef="let r" class="r-10pc-column  r-no-bottom-border"> {{r.date | date: 'dd/MM/yyyy'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-10pc-column r-th">Customer name</th>
            <td mat-cell *matCellDef="let r" class="r-10pc-column r-no-bottom-border"> {{ r.customer?.name ?? 'N/A'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="contactName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-10pc-column r-th">Contact name</th>
            <td mat-cell *matCellDef="let r" class="r-10pc-column r-no-bottom-border"> {{ r.customer?.contactName ??
                'N/A'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="contactEmail">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-10pc-column r-th">Contact email</th>
            <td mat-cell *matCellDef="let r" class="r-10pc-column r-no-bottom-border"> {{ r.customer?.email ?? 'N/A'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="country">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">Country</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{ r.customer?.country?.enName ??
                'N/A'}} </td>
        </ng-container>
        <ng-container matColumnDef="payingTickets">
            <th mat-header-cell *matHeaderCellDef class="r-5pc-column r-th">Paying tickets</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{r.payingTickets}} </td>
        </ng-container>
        <ng-container matColumnDef="freeTickets">
            <th mat-header-cell *matHeaderCellDef class="r-5pc-column r-th">Free tickets</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{r.freeTickets}} </td>
        </ng-container>
        <ng-container matColumnDef="fee">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">Fee</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{r.fee?.target ?? 'N/A'}}
            </td>
        </ng-container>
        <ng-container matColumnDef="rate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">Rate</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{r.appliedRate | currency: 'EUR'
                : 'symbol' :
                undefined :'fr-BE'}} </td>
        </ng-container>
        <ng-container matColumnDef="discount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">Discount</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{r.appliedDiscount / 100 |
                percent}}
            </td>
        </ng-container>
        <ng-container matColumnDef="invoiceNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">Invoice #</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{ r.invoice?.number ?? 'N/A' }}
            </td>
        </ng-container>
        <ng-container matColumnDef="paymentMode">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">Payment mode</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"> {{ r.paymentMode | enumLabel:
                paymentOptions }}
        </ng-container>
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="r-5pc-column r-th">Payment status</th>
            <td mat-cell *matCellDef="let r" class="r-5pc-column r-no-bottom-border"
                [matTooltip]="r.invoice | invoiceListFormatter"> {{ (r.invoice?.status | enumLabel : invoiceStatuses)
                ??'No
                invoice'}} </td>
        </ng-container>
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="r-th" style="min-width: 75px">Actions </th>
            <td mat-cell *matCellDef="let r" class="r-no-bottom-border">
                <button mat-icon-button color="primary" title="Edit" (click)="editRegistration(r)"
                    [disabled]="!r.customer">
                    <mat-icon>edit</mat-icon>
                </button>
                <button mat-icon-button color="primary" title="Get invoice {{ r.invoice?.number ?? 'N/A' }}"
                    (click)="generateInvoice(r)" [disabled]="!r.invoice?.number">
                    <mat-icon>receipt</mat-icon>
                </button>
                <button mat-icon-button color="primary" title="Mark as paid" (click)="markAsPaid(r)"
                    [disabled]="(!r.invoice?.number) || (r.invoice?.status === 'PAID')">
                    <mat-icon>paid</mat-icon>
                </button>
                <button mat-icon-button color="primary"
                    [class.reminder-sent]="r.reminderSentOn && !((!r.invoice?.number) || (r.invoice?.status === 'PAID'))"
                    title="{{r.reminderSentOn ? 'Reminder last sent on ' + (r.reminderSentOn | date:'dd/MM/yyyy') : 'Send reminder email'}}"
                    (click)="sendReminderEmail(r)" [disabled]="(!r.invoice?.number) || (r.invoice?.status === 'PAID')">
                    <mat-icon>email</mat-icon>
                </button>
                <button mat-icon-button color="primary" title="Mark as deleted" (click)="deleteRegistration(r)">
                    <mat-icon>delete</mat-icon>
                </button>
            </td>
        </ng-container>

        <!-- Rate row -->
        <ng-container matColumnDef="rateDetails">
            <td mat-cell [attr.colspan]="columnsToDisplay.length" *matCellDef="let r"
                style="padding:0px 80px 0px; border-bottom-style: none;">
                <u>Fee details</u>:
                @if (r.earlyBird) {
                <mat-icon style="margin-bottom: -5px;">flutter_dash</mat-icon>
                }
                @if (event?.usesPromoCodes) {
                Base rate: {{r.fullRate | currency: 'EUR' : 'symbol' : undefined :'fr-BE'}} Effective rate:
                {{r.discountRate | currency: 'EUR' : 'symbol' : undefined :'fr-BE'}} Discount:
                {{(r.appliedDiscountType ==='PERCENT' ? (r.appliedDiscount / 100 | percent:'1.2-2') : (r.appliedDiscount
                |
                currency: 'EUR' : 'symbol' : undefined :'fr-BE')) }}
                @if (r.freeTickets > 0) {
                Paying tickets: {{r.payingTickets}} Free tickets: {{r.freeTickets}}
                }
                } @else {
                Rate: {{r.fullRate | currency: 'EUR' : 'symbol' : undefined :'fr-BE'}} Paying tickets:
                {{r.payingTickets}}
                Free tickets: {{r.freeTickets}}
                }
            </td>
        </ng-container>

        <!-- Attendee row -->
        <ng-container matColumnDef="attendees">
            <td mat-cell [attr.colspan]="columnsToDisplay.length" *matCellDef="let r" style="padding:0px 80px 0px">
                <u>Registered attendees</u>: {{r.attendees | attendeeListFormatter}} ({{r.organisation}})
            </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
        <tr mat-row *matRowDef="let row; columns: ['rateDetails'];" style="height: 30px; "></tr>
        <tr mat-row *matRowDef="let row; columns: ['attendees'];" style="height: 30px"></tr>

        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">No data available</td>
        </tr>
    </table>
    <mat-paginator #attendeePaginator [pageSize]="pageSize" [pageIndex]="pageIndex" [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="showFirstLastButtons"></mat-paginator>

    <div class="r-button-row">
        <button matFab extended type="button" class="r-action-button"
            (click)="addRegistration()"><mat-icon>add</mat-icon>Add</button>
    </div>
</div>